import { render, staticRenderFns } from "./TheSideBar.vue?vue&type=template&id=53167ce2&scoped=true&"
import script from "./TheSideBar.vue?vue&type=script&lang=js&"
export * from "./TheSideBar.vue?vue&type=script&lang=js&"
import style0 from "./TheSideBar.vue?vue&type=style&index=0&id=53167ce2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53167ce2",
  null
  
)

export default component.exports